<template>
    <div class="bg">
        <!-- 建筑图组件 -->
        <homeConstruction></homeConstruction>
        <h1 @click="rote()" class="title">{{title}}</h1>    
        <h2 id="subtitle" class="subtitle" :style="'margin-left:-'+marginleft+'px'">
            <img src="../../assets/img/sub_dre_left.png" alt=""/>
            <span class="text_inner">
            <div class="pull-left allchild" @click="openDialog()">
                <span class="pull-left"></span>
                <span class="pull-left showBadge">{{subtitle}}<el-badge v-if="showBadge&&isShowTip" class="item" value=" "></el-badge></span>
                <span class="pull-left"></span> 
            </div>
            </span>
            <img src="../../assets/img/sub_dre_right.png" alt=""/>
        </h2>
        <!-- 左侧栏 -->
        <div class="side_bar left_side" id="sideBar" :style="'margin-top:-'+marginTop+'px'" :class="{hinden_left:collapsed}">
            <div class="side pull-left" :class="{hinden_left:collapsed}"> 
                <div class="home_side" v-show="!collapsed">      
                    <h1>通知</h1>
                    <left ref="left" :NoticList1="NoticList" :currentPage1="currentPage"></left>  
                </div>
                <div class="menu-toggle" @click="leftoggle()">
                    <i class="iconfont icon-outdent" v-show="!collapsed" title="收起"></i>
                    <i class="iconfont icon-indent" v-show="collapsed" title="展开"></i>
                </div>      
            </div>
        </div>
        <!-- 右侧栏 -->
        <div class="side_bar right_side" :style="'margin-top:-'+marginTop+'px'" :class="{hinden_right:collapsed1}">
            <div class="side pull-right" :class="{hinden_right:collapsed1}">
                <div class="home_side"  v-show="!collapsed1">
                    <h1>{{subtit}}</h1>
                    <right ref="right"></right>
                </div>
                <div class="menu-toggle menu-toggle1" @click="rightToggle()">
                    <i class="iconfont icon-indent" v-show="!collapsed1" title="收起"></i>
                    <i class="iconfont icon-outdent" v-show="collapsed1" title="展开"></i>
                </div>
                <!-- 楼层 -->
                <div v-show="isShow && floorListLength != 0" class="floor_list" :style="collapsed1?'left:-125px;':''">          
                    <el-button :class="btnDisable1 ? 'btndisabled' : 'floor_list_btn'"  icon="el-icon-arrow-up" :disabled="btnDisable1" @click="upFloor"></el-button>
                    <div class="showList" style="overflow:hidden;max-height:200px;" :style="isShow ? 'height:' + floorListLength * 40 + 'px;' : '' ">
                      <ul class="floor_list_ul" ref="floorListUl" style="scrollbar-width: none;" @wheel.prevent="wheelList(event)" :style="isShow ? 'height:' + floorListLength * 40 + 'px;' : '' ">
                        <li v-for="(item,index) in floorList" :key="index" :class="item.active ? 'active' : ''" @click="floorActive(item.id,item.floorIndex,index)">{{item.floorIndexs}}</li>
                      </ul>
                    </div>
                    <el-button :class="btnDisable2 ? 'btndisabled' : 'floor_list_btn'" icon="el-icon-arrow-down" :disabled="btnDisable2" @click="downFloor"></el-button>
                </div>              
            </div>
        </div>
        <!-- 建筑列表弹窗 -->
        <el-dialog title="建筑列表" class="list_dialog" :visible.sync="dialogVisible" width="480px">
            <gemini-scrollbar class="build-scrollbar" :autoshow="true"  :forceGemini="true">
                <div class="dialog_body">
                    <ul class="dialog_con">
                        <li v-for="(item,index) in dialogBuildList" :key="index">
                            <h3 class="clearfix">
                                <span :class="{'red_text': item.id == radio1}" :key="index" @click="handerCustomer(item)">{{item.label}}
                                    <b v-for="(items,indexs) in item.children" :key="indexs">
                                        <em v-for="(todo,indext) in redArray" :key="indext" :class="{tip_detailForm:items.id == todo}"></em>
                                    </b>
                                  </span>
                                <i :class="!item.active ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click="handle(item)"></i>
                            </h3>
                            <div v-show="item.active == true">
                                <p class="clearfix" :class="{'red_text': items.id == radio1}" v-for="(items,indexs) in dialogBuildList[index].children" :key="indexs" @click="handerFloor(item,items)"><span>{{items.label}}</span>
                                    <span v-for="(todo,indext) in redArray" :key="indext"><em v-if="items.id == todo"></em></span>
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
            </gemini-scrollbar>        
            <div slot="footer" class="dialog-footer"></div>
        </el-dialog>
    </div>
</template>
<script>
    import left from '@/page/home/left'//左侧栏
    import right from '@/page/home/right'//右侧栏
    import homeConstruction from '@/components/homeConstruction/index.vue'//建筑图组件
    import {ajaxFuncJson,SocketUrl} from '@/api/ajax';
    import {mapState,mapGetters,mapActions} from 'vuex'
    export default {
        components: {
            homeConstruction,
            left,
            right
        },
        name: 'Home',
        data () {
            return {
                title:'智慧消防监测预警管理系统',
                subtitle:'', 
                subtit: '',
                collapsed: false, //左侧展开收起收起按钮
                collapsed1: false, //右侧展开收起收起按钮
                marginleft:'',//子标题距离屏幕左边的距离
                marginTop:'',//侧栏距离屏幕顶部距离
                dialogVisible: false,//建筑列表弹窗
                dialogBuildList: [],//弹窗内建筑列表信息
                activeNames: ['1'],//显示折叠面板第一条
                customerId:'',//左侧导航客户ID
                custId:'',//弹窗列表客户ID     
                floorList:[],//楼层
                floorid: '', // 默认第一层id
                showBadge: false, // 红点警告显示隐藏
                btnDisable1: false, // 上一层按钮状态
                btnDisable2: false, // 下一层按钮状态
                isShow: false, // 楼层隐藏显示
                NoticList:[],//websocket推送通知列表信息
                currentPage:1,//websocket推送通知列表当前页
                socketNotic:null,//websocket对象 通知列表  
                socketBuild:null,//websocket对象 建筑列表  
                socketMonitor:null,//websocket对象 监测列表  
                radio1: -1,
                floorListLength: '',
                isShowTip:true,
                event: null,
                redArray:[],
                windowResize:null,

                socketNoticClose :1,//我关闭的
                lockReconnect: false,//是否真正建立连接
                timeoutnum: null,//断开 重连倒计时
                timeoutnumSucc: null,//断开 重连倒计时
                timeoutnumSucc1: null,//断开 重连倒计时

            }
        },
        updated() {
          let _this = this;
          if (_this.$store.state.floorList != null && _this.$store.state.floorList.length > 0) {
            _this.$refs.floorListUl.style.marginTop = _this.floorListIndexL1 + 'px';
          }
        },
        computed: {
          floorListIndexL1() {
            return this.$store.state.floorListIndexL1;
          },
          sum: {
            get() {
              return this.$store.state.sum
            },
            set(val) {
              this.$store.state.sum = val
            },
          },
        },        
        created() {
            //获取建筑列表弹窗信息
            this.getBuild(); 
            //获取监测列表总览图
            this.getAllMonitor();
            this.getBuilding();
        }, 
        watch: {
          floorList(val) {
            let index = val.findIndex( e => e.active == true);
            if (val.length == 1) {
                this.btnDisable1 = true;
                this.btnDisable2 = true;
            } else {
              if (index == 0) {
                  this.btnDisable1 = true;
                  this.btnDisable2 = false;
              } else if (index == val.length - 1) {
                  this.btnDisable2 = true;
                  this.btnDisable1 = false;
              } else {
                  this.btnDisable1 = false;
                  this.btnDisable2 = false;
              }
            }
          }
        },
        mounted() {
            //计算距离
            var _this=this;
            _this.windowResize= function (){
                //子标题距离屏幕左边的距离
                var left = document.getElementById("subtitle");    
                if(left){
                    _this.marginleft=left.clientWidth/2;
                } else{
                    _this.marginleft = 0
                }
                //侧栏距离屏幕顶部距离
                var top = document.getElementById("sideBar");    
                if(top){
                    _this.marginTop=top.clientHeight/2;
                }else{
                    _this.marginTop = 0
                }
            };
            _this.windowResize();
          //窗口变化动态计算距离
            window.addEventListener('resize',_this.windowResize);
            this.init();    //调用websocket方法,获取通知列表信息
            this.initBuild();   //调用websocket方法,获取建筑列表弹窗信息
            this.initMonitor();   //调用websocket方法,获取监测列表信息
            this.$refs.floorListUl.style.marginTop = sessionStorage.getItem('floorListUlTop')
        },
        destroyed () {
            // 销毁监听websocket
            this.socketNotic.close();//销毁通知列表websocket推送信息
            this.socketBuild.close();//销毁建筑列表websocket推送信息
            this.socketMonitor.close();//销毁监测列表websocket推送信息
            let _this=this;
          window.removeEventListener("resize",_this.windowResize)
        },  
        methods:{
            // 楼层列表
            wheelList(event) {
              let _this = this;
              let ev = event || window.event;
              if (ev.deltaY < 0) {  // 向上滑动
                if (_this.sum *40 + parseInt(_this.$refs.floorListUl.style.marginTop) >= 0) {
                  _this.$refs.floorListUl.style.marginTop = 0;
                } else {
                  _this.sum += 1
                  _this.$refs.floorListUl.style.marginTop = Math.abs(_this.sum *40) + parseInt(_this.$refs.floorListUl.style.marginTop) + 'px'
                }
              } else if (ev.deltaY > 0) {  //向下滑动
                if (_this.sum *40 + parseInt(_this.$refs.floorListUl.style.marginTop) <= -(_this.floorList.length -5) * 40 ) {
                  _this.$refs.floorListUl.style.marginTop = -(_this.floorList.length - 5) * 40 + 'px'
                } else {
                  _this.sum -= 1
                  _this.$refs.floorListUl.style.marginTop = - Math.abs(_this.sum *40) + parseInt(_this.$refs.floorListUl.style.marginTop) + 'px'
                }
              }
            },
            rote(){
              sessionStorage.setItem('collapsed',false)
              this.$router.push({path:'/content/Monitoring'})
              sessionStorage.setItem('router','Monitoring')
              sessionStorage.setItem('target','0')
            },
            // 获取左侧导航信息
            getBuilding() {
              if(this.isAuth('common:interface')) {
                let params = {
                    buildingName: '',
                    target: '0',
                }
                ajaxFuncJson('/basicData/getBuilding',params).then(res=>{
                    if(res.data.status==200&&res.data.data.length>0) {
                        // 查询建筑列表
                        for(var item in res.data.data) {
                            for(var ite in res.data.data[item].children) {
                                if(res.data.data[item].children[ite].isShowRed==1){
                                    res.data.data[item].showRed = true;     
                                }
                            }
                        }
                        sessionStorage.setItem('leftData',JSON.stringify(res.data.data));
                        sessionStorage.setItem('remark','0');
                        sessionStorage.setItem('customerId',res.data.data[0].id); // 默认缓存第一个客户id
                        if (res.data.data[0].children != 0) {
                            this.$store.state.buildingId = res.data.data[0].children[0].id;
                            sessionStorage.setItem('menuS',res.data.data[0].children[0].id); // 默认选中第一个建筑id
                            sessionStorage.setItem('Name', res.data.data[0].children[0].label); // 默认缓存第一个客户名
                            sessionStorage.setItem('buildingId',res.data.data[0].children[0].id); //默认缓存第一个客户
                            sessionStorage.setItem('activeIndex',res.data.data[0].children[0].id);
                            this.$store.state.menuS = res.data.data[0].children[0].id;
                        }else{
                            sessionStorage.setItem('menuS',''); // 默认选中第一个建筑id
                            sessionStorage.setItem('Name', ''); // 默认缓存第一个客户名
                            sessionStorage.setItem('buildingId',''); //默认缓存第一个客户
                            this.$store.state.menuS = '';
                        }
                        sessionStorage.setItem('showcus','0')  // 客户是否可以点击1表示可以0不可以
                        sessionStorage.setItem('differentiate',true);
                        sessionStorage.setItem('rightList',false)
                        sessionStorage.setItem('btnShow',true)
                        sessionStorage.setItem('navAddShow',false);
                        this.$store.state.navAddShow = false;
                        this.$store.dispatch('getLeftDataList',res.data.data)
                        this.getpointMap(sessionStorage.getItem('customerId'));
                    }
                });
              }
            },
            getpointMap(customerId,a) {
              if (this.isAuth('common:interface') && sessionStorage.getItem('remark') == '0') {
                // let params = {
                //     id: customerId,
                // }
                // ajaxFuncJson('/building/showBuilding',params).then(res=>{
                //     sessionStorage.setItem('pointData',JSON.stringify(res.data.data))
                //     this.$store.dispatch('getRightPoint',res.data.data);
                //     this.isShow = false;
                // });
              }
            },
            //获取监测列表总览图
            getAllMonitor(){
              if (this.isAuth('common:interface')) {
                // let params = {
                //     id: sessionStorage.getItem('customerId')
                // }
                // if(sessionStorage.getItem('remark') == '0'){
                //   ajaxFuncJson('/building/showBuilding',params).then(res=>{
                //       sessionStorage.setItem('pointData',JSON.stringify(res.data.data))
                //       this.$store.dispatch('getRightPoint',res.data.data);
                //   });
                // }
              }
            },
            //建筑列表弹窗
            openDialog(){
                this.dialogVisible=true;
            },
            ajaxShowRed(){
                ajaxFuncJson('/basicData/getShowRedBuildIdList',{pageType:0,customerId:sessionStorage.getItem('customerId')}).then(res=>{
                  if(res.data.status == 200){
                    this.redArray = res.data.data; //存储圆点
                    this.dialogBuildList.map( k => {
                      k.children.map(e => {
                        res.data.data.map( i => {
                          if (e.id == i) {
                            this.redArray.push(k.id)
                          }
                        })
                      })
                    })
                    if (this.redArray.findIndex( e => e == this.custId) > -1) {
                      this.isShowTip=true;
                    } else {
                      this.isShowTip=false;
                    }
                    if(res.data.data.length != 0){
                      this.showBadge = true;  
                    }
                  }
                })
            },
            //获取建筑列表弹窗信息
            getBuild(){
              if(this.isAuth('common:interface')) {
                let params={
                    buildingName: '',
                    target: '0',
                }
                ajaxFuncJson('/basicData/getBuilding',params).then(res=>{
                    if(res.data.status==200) {
                        this.dialogBuildList = res.data.data;
                        for(var item in this.dialogBuildList) {
                            this.dialogBuildList[item].active = false;
                            this.dialogBuildList[0].active = true;
                        }
                        this.subtitle=res.data.data[0].label;
                        this.subtit=res.data.data[0].label;
                        this.custId=res.data.data[0].id;
                        sessionStorage.setItem('custId', res.data.data[0].id);
                        sessionStorage.setItem('buildId', '');
                        this.radio1 = sessionStorage.getItem('custId');
                        this.$refs.right.getMonitor();      
                        this.$refs.right.getAlarmNotice();
                        this.ajaxShowRed(); //小红点
                    }
                });
              }
            },
            //弹窗列表客户伸缩按钮点击
            handle(item) {
                if(item.active == true) {
                    item.active = false;
                } else {
                    item.active = true;
                }
            },
            //弹窗列表客户点击 获取客户ID
            handerCustomer(item) {
                if(this.redArray.indexOf(item.id) != -1){
                  this.isShowTip=true;
                }else{
                  this.isShowTip=false;
                }
                this.radio1 = item.id;
                this.subtit = item.label;
                this.subtitle=item.label;
                sessionStorage.setItem('custId', item.id);
                sessionStorage.setItem('buildId', '');
                this.getpointMap(sessionStorage.getItem('custId'),'1')
                //更新右侧列表
                this.$refs.right.getMonitor();      
                this.$refs.right.getAlarmNotice();
                this.initMonitor()
            },
            //弹窗列表点击 获取楼层ID
            handerFloor(ite,item) {
                if(ite == ''){
                  ite = JSON.parse(sessionStorage.getItem('leftData'));
                      this.subtit = item.buildingName;
                      this.subtitle=item.buildingName;
                }else{
                      this.subtit = item.label;
                      this.subtitle=item.label;
                }

                if(this.redArray.indexOf(item.id) != -1){
                  this.isShowTip=true;
                }else{
                  this.isShowTip=false;
                }
                this.radio1 = item.id;
                this.floorList=[];
                sessionStorage.setItem('custId', ite.id);
                //获取建筑ID并存储
                sessionStorage.setItem('buildId', item.id);
                //获取楼层信息列表
                if(this.isAuth('common:interface')) {
                  let params={
                    buildingId: item.id,
                  }
                  ajaxFuncJson('/basicData/getBuildingFloor',params).then(res=>{
                    if(res.data.status==200&&res.data.data.length>0){
                      let Zfloor = [];
                      let Ffloor = [];
                      // 查询楼层列表
                      res.data.data.forEach((item, index) => { 
                        if(item.markIsShow == true){
                          if(item.floorIndexs>0){
                            Zfloor.push(item.floorIndexs);           
                            item.floorIndexs ='L'+item.floorIndexs;
                          }else{
                            Ffloor.push(item.floorIndexs) ;          
                            item.floorIndexs='B'+Math.abs(item.floorIndexs);
                          }
                          this.floorList.push(item);
                        }
                      });
                      this.isShow=true
                      if(this.floorList.length > 0){
                        this.floorList.map(e => {
                          if(Zfloor.length != 0 && Ffloor.length != 0){
                            if(e.floorIndexs.indexOf('L') != -1){
                              if (e.floorIndexs == ('L'+ Zfloor[Zfloor.length -1])) {  // 默认L1层
                                  e.active = true;
                                  sessionStorage.setItem('floorid',e.id)
                              }
                            }
                          }else{
                            if(e.floorIndexs.indexOf('L') != -1){
                              if (e.floorIndexs == ('L'+ Zfloor[Zfloor.length -1])) {  // 默认L1层
                                  e.active = true;
                                  sessionStorage.setItem('floorid',e.id)
                              }
                            }else{
                              if (e.floorIndexs == ('B'+ Math.abs(Ffloor[0]))) {  // 默认L1层
                                  e.active = true;
                                  sessionStorage.setItem('floorid',e.id)
                              }
                            }
                          }
                        })       
                      }else{
                        this.floorList = [];
                      }
                      res.data.data.map( e => {
                          if(Zfloor.length != 0 && Ffloor.length != 0){
                            if(e.floorIndexs.indexOf('L') != -1){
                              if (e.floorIndexs == ('L'+ Zfloor[Zfloor.length -1])) {  // 默认L1层
                                 this.floorid = e.id;
                              }
                            }
                          }else{
                            if(e.floorIndexs.indexOf('L') != -1){
                              if (e.floorIndexs == ('L'+ Zfloor[Zfloor.length -1])) {  // 默认L1层
                                 this.floorid = e.id;
                              }
                            }else{
                              if (e.floorIndexs == ('B'+ Math.abs(Ffloor[0]))) {  // 默认L1层
                                  this.floorid = e.id;
                              }
                            }
                          }
                      })
                      this.floorListLength = this.floorList.length
                      if (this.floorList.length > 5) {
                        if (this.floorList.findIndex( e => e.floorIndex == 1) > 4) {
                          this.$store.state.floorListIndexL1 = - (this.floorList.findIndex( e => e.floorIndex == 1) - 4) * 40;
                        } else {
                          this.$store.state.floorListIndexL1 = 0
                        }
                      } else if (this.floorList.length == 0){

                      } else {
                          this.$store.state.floorListIndexL1 = 0
                      }
                      let params = {
                          buildingId: item.id,
                          customerId: this.custId,
                          floorId: this.floorid,
                          remark: '1'
                      }
                      ajaxFuncJson('/basicData/getBuildwithMonitor',params).then(res=>{
                          sessionStorage.setItem('floor','1'); //点击客户还是楼层0表示客户
                          sessionStorage.setItem('pointData',JSON.stringify(res.data.data))
                          this.$store.dispatch('getRightPoint',res.data.data)
                      });          
                    }else{
                      this.isShow=false
                    }         
                  });
                }
                //更新右侧列表
                this.$refs.right.getMonitor();      
                this.$refs.right.getAlarmNotice();
                this.initMonitor()
            },         
            //左侧按钮折叠方法
            leftoggle(){
                this.collapsed=!this.collapsed
            },
            //右侧按钮折叠方法
            rightToggle(){
                this.collapsed1=!this.collapsed1
            },
            // 上一层
            upFloor() {
              let index = this.floorList.findIndex( (e,index) => sessionStorage.getItem('floorIndex') == e.floorIndex) - 1
              if (index > -1) {
                if (index < this.floorList.length - 5) {
                  if (index <= 4) {
                    this.$refs.floorListUl.style.marginTop = 0;
                    this.$store.state.floorListIndexL1 = 0;
                    sessionStorage.setItem('floorListUlTop1','0px')
                  } else if(index > 4) {
                    this.$store.state.floorListIndexL1 = 40 - (index-3) * 40;
                    this.$refs.floorListUl.style.marginTop  = (40  - (index -3) * 40) + 'px';
                    sessionStorage.setItem('floorListUlTop1',this.$refs.floorListUl.style.marginTop)
                    if (this.$refs.floorListUl.style.marginTop >= 0) {
                      this.$store.state.floorListIndexL1 = 0;
                      this.$refs.floorListUl.style.marginTop = 0;
                      sessionStorage.setItem('floorListUlTop1','0px')
                    }
                  }
                }
                this.floorActive(this.floorList[index].id,this.floorList[index].floorIndex)
              }
              if (index == 0) {
                  this.btnDisable1 = true;
                  this.btnDisable2 = false;
              } else {
                  this.btnDisable1 = false;
                  this.btnDisable2 = false;
              }
            },
            // 下一层
            downFloor() {
                let index = this.floorList.findIndex( (e,index) => sessionStorage.getItem('floorIndex') == e.floorIndex) + 1
                if (index < this.floorList.length) {
                    this.floorActive(this.floorList[index].id,this.floorList[index].floorIndex)
                    if (index > 4) {
                      this.$store.state.floorListIndexL1  ='-' + (index - 4) * 40;
                      sessionStorage.setItem('floorListUlTop1',this.$store.state.floorListIndexL1 + 'px')
                    }
                }
                if (index == this.floorList.length - 1) {
                    this.btnDisable2 = true;
                    this.btnDisable1 = false;
                } else {
                    this.btnDisable2 = false;
                    this.btnDisable1 = false;
                }
            },
            // 楼层点击
            floorActive(id,index,i) {
              this.$refs.floorListUl.style.marginTop = this.$refs.floorListUl.style.marginTop;
              this.$store.state.floorListIndexL1 = parseInt(this.$refs.floorListUl.style.marginTop)
              sessionStorage.setItem('floorListUlTop1',this.$refs.floorListUl.style.marginTop)
              let ins = this.floorList.findIndex( e => index == e.floorIndex);
              if (ins == 0) {
                this.btnDisable1 = true;
                this.btnDisable2 = false;
              } else if (ins == this.floorList.length - 1) {
                this.btnDisable1 = false;
                this.btnDisable2 = true;
              } else {
                this.btnDisable1 = false;
                this.btnDisable2 = false;
              }
                sessionStorage.setItem('floorid',id)      // 缓存楼层id
                sessionStorage.setItem('floorIndex',index)      // 缓存索引
                this.floorList.map( e => {
                    if(e.id == id) {
                      e.active = true;
                      let params = {
                        buildingId: e.buildingId,
                        customerId: this.custId,
                        floorId: e.id
                      }
                      ajaxFuncJson('/basicData/getBuildwithMonitor',params).then(res=>{
                        sessionStorage.setItem('pointData',JSON.stringify(res.data.data))
                        this.$store.dispatch('getRightPoint',res.data.data)
                      })
                     
                    } else {
                      e.active = false
                    }
                })
                sessionStorage.setItem('floorData',JSON.stringify(this.floorList));
                this.floorList=JSON.parse(sessionStorage.getItem('floorData'))
                this.initMonitor()
            }, 
            handleChange(val) {
            },
            //====调用websocket方法====
            //................................websocket方法,获取通知列表信息.................
            //初始化weosocket 
             // 心跳
            timeoutnumSuccF(){
                var that = this;
                that.timeoutnumSucc && clearTimeout(that.timeoutnumSucc);
                that.timeoutnumSucc1 && clearTimeout(that.timeoutnumSucc1);
                that.timeoutnumSucc = setTimeout(function () {
                  if (that.socketNotic.readyState===1) {
                    that.socketNotic.send("monitorReconnection");
                  }else{
                      //do something
                  }
                  that.timeoutnumSucc1 = setTimeout(function () {
                    // console.log('关闭')
                    that.socketNotic.close();//销毁通知列表websocket推送信息
                    that.socketBuild.close();//销毁建筑列表websocket推送信息
                    that.socketMonitor.close();//销毁监测列表websocket推送信息
                  },10000);
                },1200000);
            },
            init(){
              var webSocketUrl = SocketUrl() 
              let token= sessionStorage.getItem('token')
              const wsuri = webSocketUrl + '/alarmNoticeRecord/getNoticeList?token='+token;//ws地址 
              if(token){
                this.socketNotic = new WebSocket(wsuri); 
                this.socketNotic.onopen = this.websocketonopen;
                this.socketNotic.onerror = this.websocketonerror;
                this.socketNotic.onmessage = this.websocketonmessage; 
                this.socketNotic.onclose = this.websocketclose;
              }    
        　　},
        　　websocketonopen() {
            console.log("通知列表连接成功");
            this.socketNoticClose = 1;//连接成功他就等于1
            this.timeoutnumSuccF()
        　　},
            //错误
        　　websocketonerror(e) {
              // console.log("通知列表连接发生错误");
        　　},
            //数据接收 
        　　websocketonmessage(e){
              if(this.$route.path==='/Home'){
                  if(e.data =="connectSuccess"){
                    this.timeoutnumSuccF()
                  }else if(e.data == 'HAVE_NEW_GROUP'){ //公告
                        this.$refs.left.getBrodList();
                  }else{
                    const res = JSON.parse(e.data);
                    this.NoticList=res  
                    //更新右侧列表
                    this.$refs.right.getMonitor();      
                    this.$refs.right.getAlarmNotice();
                  }
              }
        　　}, 
            //数据发送 
        　　websocketsend(agentData){
                //this.websock.send(agentData); 
        　　}, 
            //关闭
        　　websocketclose(e){ 

                // 第一个失败  先关闭其他两个  然后同时开启
                this.socketBuild.close();//销毁建筑列表websocket推送信息
                this.socketMonitor.close();//销毁监测列表websocket推送信息


                // console.log("通知列表连接断开 (" + e.code + ")"); 
                // console.log("通知列表连接断开 (" + e.code + ")"); 
                if(this.socketNoticClose == 2)return;
                var that = this;
                if(that.lockReconnect) {
                    return;
                };
                that.lockReconnect = true;
                //没连接上会一直重连，设置延迟避免请求过多
                that.timeoutnum && clearTimeout(that.timeoutnum);
                that.timeoutnum = setTimeout(function () {
                    //新连接
                    that.init();    //调用websocket方法,获取通知列表信息
                    that.initBuild();   //调用websocket方法,获取建筑列表弹窗信息
                    that.initMonitor();   //调用websocket方法,获取监测列表信息
                    that.lockReconnect = false;
                },10000);
        　　},

            //..................................websocket方法,获取建筑列表弹窗信息........................
            //初始化weosocket
            initBuild(){  
              var webSocketUrl = SocketUrl()    
              let customerId= sessionStorage.getItem('customerId') 
              let token = sessionStorage.getItem('token');
              const wsuri = webSocketUrl + '/common/getbuildingList?customerId='+customerId+'&pageType=0'+'&token='+token
              if(token){
                this.socketBuild = new WebSocket(wsuri); 
                this.socketBuild.onopen = this.Buildonopen;
                this.socketBuild.onerror = this.Buildonerror;
                this.socketBuild.onmessage = this.Buildonmessage; 
                this.socketBuild.onclose = this.Buildclose;
              }
            },
            Buildonopen() {
              // console.log("建筑列表连接成功");
        　　},
            //错误
            Buildonerror(e) {
                //  console.log("建筑列表连接发生错误");
　　        },
            //数据接收 
        　　Buildonmessage(e){
                const res = JSON.parse(e.data);
                if(res[0].children){
                sessionStorage.setItem('a',JSON.stringify(1))
                this.dialogBuildList=res[0];
                this.ajaxShowRed(); //小红点
                this.subtitle=res[0].label;
              }
        　　},
            //数据发送 
            Buildsend(agentData){
              //this.websock.send(agentData); 
            }, 
            //关闭 
            Buildclose(e){
              //  console.log("建筑列表连接断开 (" + e.code + ")"); 
            },

            //....................................websocket方法,获取监测点信息............................
            //初始化weosocket   
            initMonitor(){   
              let customerId= sessionStorage.getItem('customerId')
              let buildingId= sessionStorage.getItem('buildId')
              let floorId= sessionStorage.getItem('floorid')
              var token = sessionStorage.getItem('token');

              var webSocketUrl = SocketUrl()
              if(buildingId&&floorId){
                const wsuri = webSocketUrl + '/monitoring/getMonitoringPointList?customerId='+ customerId + '&buildingId=' + buildingId + '&floorId=' + floorId +'&token='+token;
                this.socketMonitor = new WebSocket(wsuri);
              }else if(buildingId){
                const wsuri = webSocketUrl + '/monitoring/getMonitoringPointList?customerId='+ customerId + '&buildingId=' + buildingId+'&token='+token;;
                this.socketMonitor = new WebSocket(wsuri);
              }else{
                const wsuri = webSocketUrl + '/monitoring/getMonitoringPointList?customerId='+ customerId+'&token='+token;;
                this.socketMonitor = new WebSocket(wsuri);
              }　　　
              
              if(token){
            　　　this.socketMonitor.onopen = this.Monitoronopen;
            　　　this.socketMonitor.onerror = this.Monitoronerror;
            　　　this.socketMonitor.onmessage = this.Monitoronmessage; 
            　　　this.socketMonitor.onclose = this.Monitorclose;
              }  　　　　　 
        　　}, 
        　　Monitoronopen() {
              // console.log("监测点连接成功");
        　　},
            //错误
        　　Monitoronerror(e) {
              // console.log("监测点连接发生错误");
        　　},
            //数据接收
        　　Monitoronmessage(e){ 
              if(sessionStorage.getItem('buildId')){
                  const res = JSON.parse(e.data);
                  sessionStorage.setItem('pointData',JSON.stringify(res))
                  this.$store.dispatch('getRightPoint',res) 
                }else{
                  let params = {
                    id: sessionStorage.getItem("customerId")
                  };
                  if(sessionStorage.getItem('remark') == '0'){
                    // ajaxFuncJson("/building/showBuilding", params).then(res => {
                    //   sessionStorage.setItem("pointData", JSON.stringify(res.data.data));
                    //   this.$store.dispatch("getRightPoint", res.data.data);
                    // });
                  }
                }

        　　},
            //数据发送 
        　　Monitorsend(agentData){
              //this.websock.send(agentData); 
        　　},
            //关闭 
        　　Monitorclose(e){
              //console.log("监测点信息连接断开 (" + e.code + ")"); 
        　　},
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped >
@import "@/assets/css/mixin.scss";
$text:#66b3ff;
$cyan:#00fcc9;
$border_color:#264480;
$grey:#8e8e8e;
.bg{
  position: relative;
  height: 100%;
  background:#102239;
 .title{
		position: absolute;
		top: 17px;
    left: 50%;
    margin-left: -260px;
    color: $text;
		font-size:24px;
		line-height: 50px;
		width: 520px;
		height: 50px;
		text-align: center;
    cursor: pointer;
    background:url(../../assets/img/home_title.png) center 0 no-repeat;
    z-index: 10;
  }
  .title:hover{
      -webkit-filter: opacity(.9);
      filter: opacity(.9); 
  }
  .subtitle{
    position: absolute;
    width: 800px;
    color: $cyan;
    font-size:$fontSizeFive;
    font-weight: normal;
    z-index: 9;
    top: 60px;
    left: 50%;
    text-align: center;
    height: 45px;
    line-height: 45px;
    .text_inner{
      display: inline-block;
      height: 30px;
      line-height: 30px;
      .allchild{
        cursor: pointer;
        margin-top: 13px;        
        span{
          display: inline-block;
          height: 30px;
          &:nth-child(1){
            width: 19px;
            background:url(../../assets/img/h_sub_left.png) center 0 no-repeat;
          }
          &:nth-child(2){
            min-width: 140px;
            background:url(../../assets/img/h_sub_center.png) repeat-x;
          }
          &:nth-child(3){
            width: 18px;
            background:url(../../assets/img/h_sub_right.png) center 0 no-repeat;
          }                 
        }
        &:hover{
          span{
              &:nth-child(1){
                -webkit-filter: opacity(.9);
                filter: opacity(.9); 
              }
              &:nth-child(2){
                -webkit-filter: opacity(.9);
                filter: opacity(.9); 
              }
              &:nth-child(3){
                -webkit-filter: opacity(.9);
                filter: opacity(.9); 
              }                 
          }          
        }
      }

    }
  }
}
.side_bar{
  position: absolute;
  top: 50%;
  width:360px;
  max-height: 800px;  
}
.left_side{  
  left: 10px;
}
.right_side{
  right: 10px;
}
.side{
  position: relative;
  width:360px;
  height: 800px;
  .menu-toggle {
      z-index: 100;
      position: absolute;
      top: 50%;
      margin-top: -20px;
      right: 0;
      @include wh(40px,40px);
      .icon-outdent,.icon-indent {
          position: absolute;
          top: 0;     
          @include wh(40px,40px);
          border: 0;
          opacity: 0.5;
          cursor: pointer;
            &:hover {
                opacity: 1;
            }
      }
      .icon-outdent {
          @include bgImg('../../assets/img/leftsvg.svg');
      }
      .icon-indent {
          @include bgImg('../../assets/img/rightsvg.svg');
      }
  }
  .menu-toggle1{
    left: 0;
  }    
}
.home_side{
  position: relative;
  color: $text;
  border:1px solid #264480;
  background: rgba(42, 74, 116, .4);  
  h1{
    height: 30px;
    line-height: 30px;  
    font-size: 14px;
    text-align: center; 
  }  
}
.right{
  margin-left: 10px;
}
.hinden_left{
  width: 0;
  .menu-toggle{
    right: -40px
  }
}
.hinden_right{
  width: 0;
  .menu-toggle{
    left: -40px
  }
}

.floor_list {
  position: absolute;
  top: 50%;
  left: -85px;
  z-index: 10;
  // margin-top: -131px;
  transform: translateY(-50%);
  border: 1px solid #254580;
  width: 62px;
}
.floor_list .btndisabled {
  width: 60px !important;
  min-width: 60px !important;
  height: 30px;
  background: rgba(35, 33, 67,.8)!important;
  color: #999 !important;
  border: none;
  border-radius: 0;
  font-size: 18px!important;
  font-weight: bold;
}
.floor_list_btn {
  width: 60px !important;
  min-width: 60px !important;
  height: 30px;
  background: rgba(35, 33, 67,.8)!important;
  color: $text !important;
  border: none;
  border-radius: 0;
  font-size: 18px!important;
  font-weight: bold;
}
.floor_list_btn:last-child {
  border-top: 1px solid #254580!important;
}
.floor_list_ul::-webkit-scrollbar {
  display: none;
}
.floor_list_ul li {
  height: 40px;
  text-align: center;
  line-height: 40px;
  color: #66b7fb;
  border-top: 1px solid #254580;
  cursor: pointer;
  font-size: 14px;
  background: rgba(35, 33, 67,.8);
}
.floor_list_ul li:hover {
  color: $cyan;
}
.floor_list_ul li.active {
  color: $cyan;
  background: rgba(44, 40, 83,.8);
}


//楼层滚动条
.floor-scrollbar{
   height: 200px;
   background: rgba(42, 74, 116, .4);
}
@media screen and (max-width: 1366px) {
  .home_side{
    height: 620px;    
  }
  .side_bar{
    height: 620px;
  }
  .side{
    height: 620px;
  }   

}
.bg .floor_list_ul {
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/page/Home/index.vue